<template>
  <div class="panel-header panel-header-lg">
    <header-chart
      
      :height="255"
      :data="chartData"
      :labels="chartLabels"
    >
    </header-chart>
  </div>
</template>

<script>
import HeaderChart from "./HeaderChart";
import total_timeline from "../../../assets/data/total_timeline.json";
export default {
  name: "overview-header",
  components: {
    HeaderChart,
  },
  data() {
    return {
      chartData: [],
      chartLabels: ["AUG", "SEP", "OCT", "NOV", "DEC", "JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC", "JAN", "FEB",],
    };
  },

  created() {
    let actualPositive = 0;
    let month = "08.";

    total_timeline.forEach((element) => {
      var tempMonth = element.date.split(" ");

      if (tempMonth[1] != month) {

        month = tempMonth[1];

        this.chartData.push(actualPositive);
        if (this.chartData[0] === 0) {
          this.chartData[0] = actualPositive;
        }
      }
      actualPositive += element.hasSymptonPositive + element.noSymptonPositive;
    });
    this.chartData.push(actualPositive);
  },
};
</script>

<style scoped>
.panel-header {
  background: linear-gradient(to right,  #e96b6b 0%, #ee5252 60%, #db0000 100%);
}
</style>
